import { ColorMappings } from "../constants/colors";

export const getColorPropsByName = (colorName, intensity = 1) => {
  return ColorMappings.find(
    (color) => color.colorName === colorName && color.intensity === intensity
  );
};

export const getColorPropsByHex = (hex) => {
  return ColorMappings.find((color) => color.backgroundColor === hex);
};

export const getRGBColorByHex = (hex, alpha) => {
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
};
